/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type UserListItem_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserList_viewer$ref: FragmentReference;
export type UserList_viewer = {|
  +usersPaginate: ?{|
    +users: ?$ReadOnlyArray<?{|
      +$fragmentRefs: UserListItem_user$ref
    |}>
  |},
  +$refType: UserList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "UserList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "sortBy",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sortDirection",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "usersPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "sortDirection",
          "variableName": "sortDirection",
          "type": "String"
        }
      ],
      "concreteType": "UsersPagination",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "users",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "UserListItem_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1b85657aec7c1c4e4f8b3fb1826f4fcc';
module.exports = node;



// WEBPACK FOOTER //
// src/components/users/__generated__/UserList_viewer.graphql.js